import React from 'react'; // Ensure React is imported
import ReactDOM from 'react-dom/client'; // Ensure ReactDOM is imported
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import './index.css'; // Import global styles
import { GoogleOAuthProvider } from '@react-oauth/google'; // Import GoogleOAuthProvider
import App from './App'; // Your main App component
import reportWebVitals from './reportWebVitals'; // Optional for web vitals

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId="289844136082-gi7gclhnubqrgrjh5i5dtvjuh715hnqn.apps.googleusercontent.com">
  <App />
</GoogleOAuthProvider>
  </React.StrictMode>
);

reportWebVitals();
